import { CardLayout, MTable } from "../v3";
import { toolReportColumns } from "../../pages/report/constants";
import { get_date } from "../generalComponets";

export const ToolReportResults = ({
  reportType,
  data = {},
  loading = false,
  paginationState,
  handlePaginationChange = () => {},
}) => {
  const rows =
    data?.rows?.map((row, index) => ({
      id: index + 1 + paginationState.page * paginationState.pageSize,
      sl: index + 1 + paginationState.page * paginationState.pageSize,
      formattedDate: get_date(row.date),
      ...row,
    })) || [];

  const totalIssuedSum = rows.reduce((sum, row) => sum + Number(row.totalIssued || 0), 0);
  const totalReturnedSum = rows.reduce((sum, row) => sum + Number(row.totalReturned || 0), 0);
  const netUsedSum = rows.reduce((sum, row) => sum + Number(row.netUsed || 0), 0);
  const currentBalanceSum = rows.reduce((sum, row) => sum + Number(row.currentBalance || 0), 0);
  const quantitySum = rows.reduce((sum, row) => sum + Number(row.quantity || 0), 0);

  const subtotal =
    data?.count > 0
      ? [
          {
            id: "subtotal",
            label: "Subtotal",
            totalIssuedSum: totalIssuedSum.toFixed(2),
            totalReturnedSum: totalReturnedSum.toFixed(2),
            netUsedSum: netUsedSum.toFixed(2),
            currentBalanceSum: currentBalanceSum.toFixed(2),
            quantitySum: quantitySum.toFixed(2),
          },
        ]
      : [];

  const allRows = [...rows, ...subtotal];
  return (
    <CardLayout>
      <MTable
        // Export data
        showExportButton // TODO: implement permission
        // Table data
        columnHeaders={toolReportColumns[reportType]}
        tableRows={allRows}
        rowCount={data.count}
        loading={loading}
        paginationModel={paginationState}
        onPaginationChange={handlePaginationChange}
      />
    </CardLayout>
  );
};
